import { render, staticRenderFns } from "./SMSTextMe.vue?vue&type=template&id=179b18ed&"
import script from "./SMSTextMe.vue?vue&type=script&lang=js&"
export * from "./SMSTextMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports